import styled from "styled-components";
export const ClientSpecificContentListWrapper = styled.div`
  .cell-group-id {
    min-width: 170px;
  }
  .cell-200-width {
    min-width: 200px;
  }
  .nestedElement {
    margin-top: 22px;
  }
  .cell-locale {
    min-width: 170px;
  }
  .cell-250-width {
    min-width: 250px;
  }
  .cell-country {
    min-width: 220px;
  }
  .ellipsis-with-tooltip {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
